'use strict';

module.exports = function (element) {
    let stickyHeader = $('.sticky-header').length >= 1 ? $('.sticky-header') : $('.no-header-section');
    let stickyHeaderHeight = stickyHeader ? stickyHeader.height() : 0;
    var position = element && element.length ? element.offset().top - stickyHeaderHeight : 0;
    $('html, body').animate({
        scrollTop: position
    }, 500);
    if (!element) {
        $('.logo-home').focus();
    }
};
